<script>
import panelPresets from 'v/PlayerControlPanelPresets.vue';
import Vue from 'vue';

export default Vue.extend({
  render(h) {
    const options = this.$options || {};
    const type = options.type || 'regular';
    const presetType = panelPresets.presetTypesMap[type];
    const childComponents = [];

    if (presetType) {
      presetType.forEach((child) => {
        const componentDeclaration = panelPresets.components[child];
        // pushing the main component props to the child presets components
        const props = componentDeclaration.props
          ? Object.keys(componentDeclaration.props).reduce((obj, prop) => {
              if (_.isDefined(this[prop])) {
                obj[prop] = this[prop];
              }
              return obj;
            }, {})
          : {};

        childComponents.push(h(child, { props }));
      });
    } else {
      const allTypes = Object.keys(panelPresets.presetTypesMap);
      console.error(
        `PlayerControlPanel: unrecognized type! type: ${type}. available types: ${allTypes}`
      );
    }

    return h(
      'div',
      {
        class: [
          'wt2-sg',
          'wt2-player-control-panel',
          type,
          this.playing ? '-playing' : null,
        ],
      },
      childComponents
    );
  },

  components: panelPresets.components,

  data: function () {
    return {
      volume: {
        current: null,
        beforeMute: null,
      },
      playing: null,
      time: {
        current: null,
        buffered: null,
        total: null,
        seekable: true,
      },
    };
  },
});
</script>
